import React, { Component } from "react";
import { Field, reduxForm, FormSection, formValueSelector } from "redux-form";

import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';

import axios from "axios";

import { TabContent, TabPane, Nav, NavItem, NavLink, Card, CardBody, Button, CardTitle, CardText, Row, Col, Pagination } from 'reactstrap';
import classnames from 'classnames';
import { connect } from "react-redux";
import PageSpinner from "../PageSpinner";
import appConfig from '../../config/config';
import OrderNotePage from "./OrderNotePage";
import OrderDocumentPage from "./OrderDocumentPage"
import OrderStatusPage from "./OrderStatusPage"
import OrderTitlePage from "./OrderTitlePage"
import {Success,Error} from "../../actions/loading"
import Banner from "../common/banner";
import AddProductForm from "./AddProductForm"
var d = [];
const orderColumns = [{
    dataField: 'ID',
    text: 'Sr No',
    sort: true,
    hidden:true,
    style: {
        width : '7%'
    }

},
{
    dataField: 'SRNO',
    text: '#',
    sort: true ,
     style: {
        width: '7%'
    }
},
{
    dataField: 'PRODUCT',
    text: 'Product',
    sort: true ,
    classes: 'id-custom-cell',
    style: function callback(cell, row, rowIndex, colIndex) { 
        return {width: '55%'}
     }
},
{
    dataField: 'NAME',
    text: 'Status',
    sort: true ,
     style: {
        width: '25%'
    }
}
];
class OrderProduct extends Component {
    constructor(...args) {
        super(...args);
        this.state = {
            showBanner: false, message: '', activeTab: '1', IsDataLoaded: false, OrderData: {}, 
            ItemId:null, IsSuccess:false, add:false, productgroup : null
        };
    }
    toggle = tab => {
        if (this.state.activeTab !== tab)
            this.setState(prevState => ({
                ...prevState, activeTab: tab
            }));
    }
    closeBanner=()=>{
        this.setState({
            showBanner: false, message: '', IsLoading:false
        });
    }
    loadData=()=>{
        axios.post(
            appConfig.apiGateway.searchOrderUrl,
            JSON.stringify({ OrderId: this.props.OrderId, Action: "OrderProduct" }),
            {
                headers:
                {
                    'Content-Type': 'application/json'
                }
            }
        ).then((response) => {
            var OrderData = JSON.parse(response.data.body);
            d = OrderData;
            var rec = {
                Address: OrderData[0].Address,
                City: OrderData[0].City,
                Zip: OrderData[0].Zip,
                State: OrderData[0].State,
                LOS: OrderData[0].LOS
            };
            if (this.state.ItemId > 0 ) 
                this.setState({ ...this.state, IsDataLoaded: true, OrderData : rec  });
            else 
                this.setState({ ...this.state, IsDataLoaded: true, OrderData : rec , 
                    ItemId : OrderData[0].ID, productgroup: OrderData[0].ProductGroup });
        });
    }
    componentDidMount() {
        this.loadData()
    }
    f(){
    }
    addPCR =()=> {
        axios.post(
            appConfig.apiGateway.updateOrderUrl, //Endpoint
            JSON.stringify({
                OrderId : this.props.OrderId,
                OrderProductId: ["PCR"],
                Action: "AddProduct",
                UserName: this.props.session.session.user.email
            })
        ).then((response) => { 
            if (response.data.body.status) {
                this.loadData();
                this.setState({ ...this.state, message:response.data.body.message,
                IsSuccess:true,showBanner:true });
            }
            else {
                this.setState({ ...this.state, message:response.data.body.message,
                    IsSuccess:false,showBanner:true });
            }
        },
        (error) => {
            this.setState({ ...this.state, message:"Unknown error",
                IsSuccess:false,showBanner:true });

        })
    }
    submit = (values) => {
    }
    Add = (val) => {
        this.setState({...this.state,add:val})
    }

    successBanner=(message) => {
        this.setState({ ...this.state, message:message,
        IsSuccess:true,showBanner:true });
        this.loadData()
    }

    render() {
        if (!this.state.IsDataLoaded)
            return (
                <>
                    <PageSpinner />
                </>
            );
            const selectRow = {
                mode: 'radio',
                hideSelectColumn: true,
                selected: [this.state.ItemId],
                classes: 'custom-class',
                clickToSelect: true,
                onSelect: (row, isSelect, rowIndex, e) => {
                    this.setState(prevState => ({
                        ...prevState, ItemId: row.ID, productgroup : row.ProductGroup
                    }));
                }
            };
        return (
            <>
                <div className="form-row mb-3">
                {this.state.showBanner && (<Banner Close={this.closeBanner} message={this.state.message} IsSuccess={this.state.IsSuccess}/>)}
                    <Card className="col-12">
                        <CardBody>
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-4">
                                        <span style={{ fontWeight: 'bold' }}>Property</span>
                                    </div>
                                </div>
                                <div className="row" >
                                    <div className="col-11">
                                        {this.state.OrderData.Address + ', ' + this.state.OrderData.State + ' - ' + this.state.OrderData.Zip}
                                    </div>
                                    
                                    <div className="col-1" style={{marginBottom:'5px'}}>
                                    <Button
                                        color="primary"
                                        // onClick={this.addPCR}
                                        onClick={()=>{
                                            console.log(this.state)
                                            this.Add(true)
                                            //this.setState({...this.state,add:true})
                                        }}
                                        >
                                        Add
                                        </Button>
                                    </div>
                                </div>
                                {(this.state.add) &&  <AddProductForm  
                                    Add={this.Add} 
                                    showBanner={this.successBanner}
                                    OrderId={this.props.OrderId}></AddProductForm> }
                                <BootstrapTable
                                    striped
                                    data={d}
                                    columns={orderColumns}
                                    keyField="ID"
                                    selectRow={selectRow}
                                />

                                {this.state.ItemId != null && (
                                    <div style={{ marginLeft: "0%", marginRight: "0%" }}>
                                        <hr style={{marginBottom:"0px",marginTop:"2px"}}/>
                                        <Nav pills>
                                            <NavItem>
                                                <NavLink
                                                    className={classnames({ active: this.state.activeTab === '1' })}
                                                    onClick={() => { this.toggle('1'); }}
                                                >
                                                    Notes
                                            </NavLink>
                                            </NavItem>
                                            <NavItem>
                                                <NavLink
                                                    className={classnames({ active: this.state.activeTab === '2' })}
                                                    onClick={() => { this.toggle('2'); }}>
                                                    Documents
                                            </NavLink>
                                            </NavItem>
                                            <NavItem>
                                                <NavLink
                                                    className={classnames({ active: this.state.activeTab === '4' })}
                                                    onClick={() => { this.toggle('4'); }}>
                                                    Report
                                            </NavLink>
                                            </NavItem>
                                            <NavItem>
                                                <NavLink
                                                    className={classnames({ active: this.state.activeTab === '3' })}
                                                    onClick={() => { this.toggle('3'); }}>
                                                    Status
                                            </NavLink>
                                            </NavItem>
                                        </Nav>
                                        <hr style={{marginBottom:"7px",marginTop:"0px"}}/>

                                        <TabContent activeTab={this.state.activeTab}>
                                            <TabPane tabId="1">
                                                {this.state.activeTab === '1' && <OrderNotePage key={this.state.ItemId} OrderProductId={this.state.ItemId} OrderId={this.props.OrderId} />}
                                            </TabPane>
                                            <TabPane tabId="2">
                                                {this.state.activeTab === '2' && <OrderDocumentPage 
                                                    OrderProductId={this.state.ItemId} 
                                                    LOS={this.state.OrderData.LOS} 
                                                    OrderId={this.props.OrderId} />}
                                            </TabPane>
                                            <TabPane tabId="4">
                                                {this.state.activeTab === '4' && this.state.productgroup == 'Title' && <OrderTitlePage  key={this.state.ItemId} OrderProductId={this.state.ItemId} OrderId={this.props.OrderId} />}
                                            </TabPane>
                                            <TabPane tabId="3">
                                                {this.state.activeTab === '3' && <OrderStatusPage key={this.state.ItemId} 
                                                        OrderProductId={this.state.ItemId} OrderId={this.props.OrderId}
                                                        Refresh={this.loadData} />}
                                            </TabPane>
                                        </TabContent>
                                    </div>
                                )}
                            </div>
  
                        </CardBody>
                    </Card>
                    
                </div>
            </>
        );
    }
}

// const validate = (formValues) => {
//     const errors = {};
//     console.log(formValues);

//     return errors;
// }
// var orderProductform = reduxForm({
//     form: 'orderProductForm',
//     validate
// })(OrderProduct);

// orderProductform = connect(
//     state => ({
//         initialValues: state.loadOrder.data
//     })
// )(orderProductform);
var orderProduct = connect(state => ({
        session: state.session
    }),
    {Success,Error}
)(OrderProduct);

export default orderProduct;
//export default OrderProduct;
